import styled from "styled-components"
import BSTable from '../../components/BSTable'
import SmallTable from '../../components/SmallTable'
import { Button } from '../../../ui/button'
import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuTrigger,
} from "../../../ui/dropdown-menu"

const MARCRecord = () => {

    const item = [
        {
            id: 1,
            head: 'File name',
            tail: 'Example',
        },
        {
            id: 2,
            head: 'Profile',
            tail: 'Example',
        },
        {
            id: 3,
            head: 'Comments',
            tail: 'Example',
        },
        {
            id: 4,
            head: 'Type',
            tail: 'Example',
        },
        {
            id: 5,
            head: 'Staged',
            tail: 'Example',
        },
        {
            id: 6,
            head: 'Status',
            tail: 'Example',
        },
    ]
    const item2 = [
        {
            id: 1,
            head: 'Matching rule applied',
            tail: 'Example',
        },
        {
            id: 2,
            head: 'Action if matching record founde',
            tail: 'Example',
        },
        {
            id: 3,
            head: 'Comments',
            tail: 'Example',
        },
        {
            id: 4,
            head: 'Action if no match found',
            tail: 'Example',
        },
        {
            id: 5,
            head: 'Item processing',
            tail: 'Example',
        },
    ]


    const columns = [
        {
            title: '卡號',
            dataIndex: 'card',
            key: 'card',
        },
        {
            title: '姓名',
            dataIndex: 'name',
            key: 'name',
        },
        {
            title: '生日',
            dataIndex: 'date_of_birth',
            key: 'date_of_birth',
        },
        {
            title: '館院',
            dataIndex: 'library',
            key: 'library',
        },
        {
            title: '類型',
            dataIndex: 'category',
            key: 'category',
        },
        {
            title: '有效日期',
            dataIndex: 'expires_on',
            key: 'expires_on',
        },
        {
            title: '最高年齡限制',
            dataIndex: 'check_out',
            key: 'check_out',
        },
        {
            title: '罰金',
            dataIndex: 'fines',
            key: 'fines',
        },
        {
            title: '備註',
            dataIndex: 'notes',
            key: 'notes',
        },
        {
            title: '',
            dataIndex: 'action',
            key: 'action',
            render: () => (
                <DropdownMenu>
                    <DropdownMenuTrigger><Button variant='outline' >選項</Button></DropdownMenuTrigger>
                    <DropdownMenuContent>
                        <DropdownMenuItem>MARC 預覽</DropdownMenuItem>
                        <DropdownMenuItem>Card 預覽</DropdownMenuItem>
                        <DropdownMenuItem>編輯書籍</DropdownMenuItem>
                        <DropdownMenuItem>新增/編輯館藏</DropdownMenuItem>
                    </DropdownMenuContent>
                </DropdownMenu>
            )
        },
    ]

    const data = [
        {
            card: 1,
            name: '王曉明',
            date_of_birth: '100/1/1',
            library: '本院',
            category: '學生',
            expires_on: '104/8/31',
            check_out: '',
            fines: '0.00',
            notes: '0',
        },
    ]
    return (
        <MainContainer>
            <Title>
                管理MARC Record
            </Title>
            <SubTitle>
                Example Record
            </SubTitle>
            <ContextBox>
                <SmallTable item={item} />
            </ContextBox>
            <ContextBox>
                <SmallTable item={item2} />
            </ContextBox>
            <Button>
                取消上傳
            </Button>
            <BSTable Data={data} columns={columns} />
        </MainContainer>
    )
}

const MainContainer = styled.div`
width: 100%;
display: flex;
justify-content: space-around;
flex-direction: column;
align-items: flex-start;
padding: 2em;
gap: 0.5em;
`

const Title = styled.div`
text-align: left;
font-size: 1.6em;
font-weight: 600;
`

const SubTitle = styled.div`
text-align: left;
font-size: 1.2em;
font-weight: 600;
color: #707070;
`

const ContextBox = styled.div`
width: 100%;
padding: 1em;
background-color: #fff;
`

const FlexBox = styled.div`
display: flex;
gap: 1em;
`

export default MARCRecord